export default "__VITE_ASSET__d05d5de9__"